import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state) {
        this.$state=$state;
    }

    $onInit() {
        this.st = new SmartTable();
        this.$state.companyId= this.companyId;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/reseller/list/reseller-list.controller.js